import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import Button from '../../Button';
import Text from '../../Text';
import DefaultInput from '../DefaultInput';
import { CopyInputStyled, CopyInputTopArea } from './styles/CopyInputStyled';

class CopyInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      buttonState: props.copyText,
    };
    this.timeoutId = null;
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  onButtonClick = () => {
    const { buttonState } = this.state;
    const { copyText, copiedText, text } = this.props;
    if (buttonState === copyText && this.timeoutId === null) {
      copy(text);
      this.timeoutId = setTimeout(() => {
        this.setState({
          buttonState: copyText,
        });
        this.timeoutId = null;
      }, 3000);
      this.setState({
        buttonState: copiedText,
      });
    }
  };

  onInputClick = (event) => {
    event.currentTarget.select();
  };

  render() {
    const { buttonState } = this.state;
    const { text, titleText, readOnly, copiedText } = this.props;

    const copied = buttonState === copiedText;

    return (
      <CopyInputStyled>
        <CopyInputTopArea>
          <Text type="uppercase" font="din_bold">
            {titleText}
          </Text>
          <Button
            text={buttonState}
            onClick={copied ? null : this.onButtonClick}
            disable={copied}
            textColor={copied ? 'green_light' : 'blue_doger'}
            hoverColor={copied ? 'green_light' : 'blue_navyblue'}
            textFont="din_bold"
            textType="uppercase"
            buttonStyle="transparent"
          />
        </CopyInputTopArea>
        <DefaultInput
          {...this.props}
          defaultValue={text}
          readOnly={readOnly}
          onInputClick={this.onInputClick}
        />
      </CopyInputStyled>
    );
  }
}

CopyInput.propTypes = {
  titleText: PropTypes.string,
  copyText: PropTypes.string,
  copiedText: PropTypes.string,
  readOnly: PropTypes.bool,
  text: PropTypes.string,
};

CopyInput.defaultProps = {
  titleText: '',
  copyText: '',
  copiedText: '',
  readOnly: false,
  text: '',
};

export default CopyInput;
